<div [chart]="chart"></div>